import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
  disabled?: boolean;
};

const IconArrowUpRight: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.1665 3.3335V10.0002C13.1665 10.2762 12.9425 10.5002 12.6665 10.5002C12.3905 10.5002 12.1665 10.2762 12.1665 10.0002V4.54085L4.35321 12.3542C4.25587 12.4515 4.12785 12.5008 3.99985 12.5008C3.87185 12.5008 3.74383 12.4522 3.6465 12.3542C3.45117 12.1588 3.45117 11.8421 3.6465 11.6468L11.4598 3.8335H5.99985C5.72385 3.8335 5.49985 3.6095 5.49985 3.3335C5.49985 3.0575 5.72385 2.8335 5.99985 2.8335H12.6665C12.7319 2.8335 12.7966 2.8469 12.8579 2.87223C12.9799 2.9229 13.0773 3.02024 13.1286 3.1429C13.1533 3.20357 13.1665 3.26816 13.1665 3.3335Z"
      fill={color}
    />
  </svg>
);

export default IconArrowUpRight;
